module.exports = {
  type: 'cart',
  id: 'cart',
  icon: 'fad fa-shopping-cart',
  title: 'ProjectDetails.cart',
  bodyClass: 'no-padding',
  hidePrices: false,
  requireShipping: true,

  form: [
    {
      id: 'coupon_code',
      type: 'text',
      label: {
        en: 'Coupon code',
      },
    }
  ],

  orderDialog: [
    {
      id: 'suppliers',
      form: [
        {
          id: 'description',
          type: 'multi',
          label: {
            en: 'Description',
            de: 'Beschreibung',
          }
        },
        {
          id: 'terms',
          type: 'checkbox',
          checkValue: true,
          required: true,
          label: {
            en: 'I have read and accepted the <a href="javascript:void 0" target="_blank">terms of service</a>.',
            de: 'Ich habe die <a href="javascript:void 0" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert'
          }
        },
        {
          id: 'privacy',
          type: 'checkbox',
          required: true,
          checkValue: true,
          label: {
            en: 'I have read and accepted the <a href="javascript:void 0" target="_blank">pricacy policy</a>.',
            de: 'Ich habe die <a href="javascript:void 0" target="_blank">Datenschutzhinweise</a> gelesen und akzeptiert'
          }
        }
      ]
    }
  ]
}
